import React, { Component } from "react";
import HcsGroup from "./hcs-group";
import HcsSubconfigControls from "./hcs-subconfig-controls";
import { ConfigurationModes } from "./hcs-constants";

export default class HcsSubConfig extends Component {
    constructor(props) {
        super(props);

        this.configure = this.configure.bind(this);
        this.subConfigEdit = this.subConfigEdit.bind(this);
    }

    configure(method, attrName, attrValue, cfgItemIndex) {
        const { data } = this.props;

        this.props.onConfig(method, attrName, attrValue, {
            subConfigMode: ConfigurationModes.SubConfigurationComplex,
            subConfigName: data.ident,
            subConfigIndex: cfgItemIndex,
            success: () => {
                
            }
        });
    }

    subConfigEdit(subConfigIndex) {
        const { data } = this.props;

        this.props.onConfig("enterSubCfgObject", null, null, {
            subConfigMode: ConfigurationModes.SubConfigurationComplex,
            subConfigName: data.ident,
            subConfigIndex: subConfigIndex,
            success: () => {

            }
        });
    }

    render() {
        const { data, hcs } = this.props;

        return (
            <li className="hcs-sub-config">
                <h3>{hcs.t.ecs(data.info.trans)}</h3>
                <ul> {
                    data.cfgobjs.map((cfgItem, index) => {
                        let itemClassNames = [ "hcs-subconfig-item" ];

                        if(!cfgItem.info.complete) {
                            itemClassNames.push("hcs-subconfig-incomplete");
                        }

                        return (
                            <li key={`hcs-subconfig-item-${data.ident}-${index}`} className={itemClassNames.join(" ")}>
                                <div>
                                    <h4 dangerouslySetInnerHTML={{ __html: cfgItem.flags ? cfgItem.flags.cfgName : cfgItem.data.NAME_TRANS }} />
                                    <h5 dangerouslySetInnerHTML={{ __html: cfgItem.flags ? cfgItem.flags.cfgDescription : "" }} />

                                    <HcsSubconfigControls
                                        hcs={hcs}
                                        data={data}
                                        controlAdd={false}
                                        onConfig={(method) => { this.configure(method, null, null, cfgItem.info.index); }}
                                    >
                                        { cfgItem.info.complete ? null : <em className="hcs-subconfig-incomplete"></em> }
                                    </HcsSubconfigControls>
                                </div>

                                <button
                                    className="hcs-subconfig-edit"
                                    onClick={_ => { this.subConfigEdit(index); }}
                                >
                                    <svg icon-id="icn-001-2-arrow-bold" version="2.0">
                                        <use href="#icn-001-2-arrow-bold"></use>
                                    </svg>
                                </button>
                            </li>);
                        }
                    )}
                </ul>
                <HcsSubconfigControls
                    hcs={hcs}
                    data={data}
                    controlDelete={false}
                    controlCopy={false}
                    onConfig={(method) => { this.configure(method, null, null, 0); }}
                />
            </li>);
    }
}
